module.exports = __webpack_public_path__ + "static/frame-mock.7871a2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/frame-mock.png
// module id = 1161
// module chunks = 112875127094159